<div
  style="position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        width: 100%;
        height: 100%;"
>
  <app-subheader-formulabar></app-subheader-formulabar>
</div>
